import React from 'react';

interface D12IconProps {
  size?: number;
  className?: string;
}

export const D12Icon: React.FC<D12IconProps> = ({ size = 24, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Dodecaedro (D12) - Uma aproximação 2D de um dado de 12 lados */}
      <path
        d="M12 2L4.5 6V18L12 22L19.5 18V6L12 2Z"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      {/* Linhas internas para mostrar as faces */}
      <path
        d="M4.5 6L12 10L19.5 6"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path
        d="M12 10V22"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      {/* Pentágono central - característica de um D12 */}
      <path
        d="M10 8L12 6L14 8L13 10H11L10 8Z"
        stroke="currentColor"
        strokeWidth="1.2"
        fill="currentColor"
        fillOpacity="0.2"
      />
      {/* Adicionar um 12 para identificar claramente como D12 */}
      <text
        x="12"
        y="16"
        fontSize="7"
        textAnchor="middle"
        fill="currentColor"
        fontWeight="bold"
      >
        12
      </text>
    </svg>
  );
};

export default D12Icon;